module.exports = __webpack_public_path__ + "static/media/circleCheck.5374d4c1.svg";